import styled from 'styled-components';

export const Warning = styled('span')`
  position: relative;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background-color: ${({ theme }) => theme.color.white};
    border-radius: ${({ theme }) => theme.x3spacePx}px;
    width: 12px;
    height: 12px;
    margin: 5px;
  }
`;
